import styled, { css } from 'styled-components'

const List = styled.ul`
  ${({ theme }) => css`
    margin: 0;
    padding: ${theme.spacing(1)};
    list-style: none;
  `}
`

const Option = styled.li`
  ${({ theme }) => css`
    &:last-of-type:not(:first-of-type) {
      border-top: 0.1rem solid ${theme.palette.grey[500]};
      padding-top: ${theme.spacing(1)};
      margin-top: ${theme.spacing(1)};
    }
  `}
`

const OptionButton = styled.button.attrs({ type: 'button' })`
  ${({ theme }) => css`
    appearance: none;
    border: none;
    background-color: transparent;
    display: block;
    width: 100%;
    padding: ${theme.spacing(1)};
    font-size: 1.8rem;
    text-align: left;

    &:hover {
      background-color: ${theme.palette.grey[100]};
    }
  `}
`

const AddressContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    gap: ${theme.spacing(1)};
  `}
`

const AddressCount = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
    font-size: 1.4rem;
    color: ${theme.palette.grey[500]};
  `}
`

export default {
  List,
  Option,
  OptionButton,
  AddressContainer,
  AddressCount,
}
